import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoPeriodicidadeCompraMultiSelectComponent } from './novo-periodicidade-compra-multi-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoPeriodicidadeCompraMultiSelectComponent],
  exports: [NovoPeriodicidadeCompraMultiSelectComponent],
})
export class NovoPeriodicidadeCompraMultiSelectModule {}
